import environment from '../environment';

const STORAGE_KEY = `@${environment.APP_NAME}:cashcounter`;

/**
 * Generates namespaced storage key for web localStorage
 * @param {string} key - Base key name
 * @returns {string} Prefixed storage key
 */
export const getStorageKey = (key) => {
  return `${STORAGE_KEY}:${key}`;
};

/**
 * Stores a value in web localStorage
 * @param {string} key - Storage key
 * @param {string|number} value - Value to store (converted to string)
 * @returns {Promise<void>}
 */
export const storeData = async (key, value) => {
  try {
    window.localStorage.setItem(getStorageKey(key), value.toString());
  } catch (e) {
    console.error('storeData error', e);
  }
};

/**
 * Stores a JSON object in web localStorage
 * @param {string} key - Storage key
 * @param {Object} value - Object to store as JSON
 * @returns {Promise<void>}
 */
export const storeJsonData = async (key, value) => {
  try {
    const jsonValue = JSON.stringify(value);
    window.localStorage.setItem(getStorageKey(key), jsonValue);
  } catch (e) {
    console.error('storeJsonData error', e);
  }
};

/**
 * Retrieves a value from web localStorage
 * @param {string} key - Storage key
 * @returns {Promise<string|null>} Stored value or null
 */
export const getData = async (key) => {
  try {
    return window.localStorage.getItem(getStorageKey(key));
  } catch (e) {
    console.error('getData error', e);
  }
};

/**
 * Retrieves and parses a JSON object from web localStorage
 * @param {string} key - Storage key
 * @returns {Promise<Object|null>} Parsed object or null
 */
export const getJsonData = async (key) => {
  try {
    let jsonValue = window.localStorage.getItem(getStorageKey(key));
    return jsonValue !== null ? JSON.parse(jsonValue) : null;
  } catch (e) {
    console.error('getJsonData error', e);
  }
};

/**
 * Deletes a value from web localStorage
 * @param {string} key - Storage key to delete
 * @returns {Promise<void>}
 */
export const deleteData = async (key) => {
  try {
    window.localStorage.removeItem(getStorageKey(key));
  } catch (e) {
    console.error('deleteData error', e);
  }
};

export const clearAll = async () => {
  try {
    window.localStorage.clear();
    console.log('clearAll()');
  } catch (e) {
    console.error('clearAll error', e);
  }
};
